import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Default icons for ranking selection
export const rankingIcons = [
  {
    value: "star",
    type: "far",
    icon: (
      <FontAwesomeIcon
        className="ranking-icons_option"
        icon={["far", "star"]}
      />
    ),
  },
  {
    value: "trophy",
    type: "far",
    icon: (
      <FontAwesomeIcon
        className="ranking-icons_option"
        icon={["far", "trophy"]}
      />
    ),
  },
  {
    value: "award",
    type: "far",
    icon: (
      <FontAwesomeIcon
        className="ranking-icons_option"
        icon={["far", "award"]}
      />
    ),
  },
  {
    value: "medal",
    type: "far",
    icon: (
      <FontAwesomeIcon
        className="ranking-icons_option"
        icon={["far", "medal"]}
      />
    ),
  },
  {
    value: "circle",
    type: "far",
    icon: (
      <FontAwesomeIcon
        className="ranking-icons_option"
        icon={["far", "circle"]}
      />
    ),
  },
];
